module.exports = __webpack_public_path__ + "img/961cacb.jpg";